<div class="content-modal">
    <h3 class="text-center">¿Se confirmo la entrega de productos?</h3>
    <div class="d-flex justify-content-center pt-3">
        <button class="btn btn-success mx-2" (click)="confirm()"
                [disabled]="loading"
                [ngClass]="{'m-loader m-loader--danger m-loader--right': loading}">Si
        </button>
        <button class="btn btn-danger mx-2" (click)="cancel()"
                [disabled]="loading"
                [ngClass]="{'m-loader m-loader--danger m-loader--right': loading}">No, devolver stock
        </button>
        <button type="button" class="btn btn-secondary mx-2" aria-label="Close" (click)="activeModal.dismiss()">Cancelar</button>
    </div>
</div>
